<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm7 md5 lg4>
        <login-card
          @login="login"
          :logo="require('@/assets/ticketko_logo.png')"
          :loading="loading"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoginCard from "@/components/card/LoginCard";
import Services from "@/services/Services";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      loading: false
    };
  },
  mounted() {
    this.$store.dispatch("dispatchUnauthorized", false);
    this.$store.dispatch("clearStore");
  },
  methods: {
    async login(userData) {
      this.loading = true;
      try {
        const user = (await Services.login(userData)).data;
        const newMenu = [];
        const newCompanyMenu = [];
        const newSubCompanyMenu = [];
        
        if(user.menu.length){
        user.menu.forEach(element => {
          console.log(element)
            const result = this.$router.options.routes.find(item => item.name.toLowerCase() == element.name && item.path == element.link )
            if(result){
              newMenu.push(element);
            }
          });
        }

        if(user.company_menu.length){
        user.company_menu.forEach(element => {
          console.log(element)
            const result = this.$router.options.routes.find(item => item.name.toLowerCase() == element.name && item.path == element.link )
            if(result){
              newCompanyMenu.push(element);
            }
          });
        }

        if(user.sub_company_menu.length){
        user.sub_company_menu.forEach(element => {
          console.log(element)
            const result = this.$router.options.routes.find(item => item.name.toLowerCase() == element.name && item.path == element.link )
            if(result){
              newSubCompanyMenu.push(element);
            }
          });
        }


        this.$store.dispatch("dispatchEmployee", {
          id: user.employee.id,
          employee_id: user.employee.employee_id,
          first_name: user.employee.first_name,
          last_name: user.employee.last_name,
          email: user.employee.email,
          gender: user.employee.gender
        });
        this.$store.dispatch("dispatchToken", user.token);

        this.$store.dispatch("dispatchClientStatus", user.client);

        if (user.company) {
          this.$store.dispatch("dispatchCompany", {
            id: user.company.id,
            name: user.company.name,
            code: user.company.code
          });
        }
        if (user.sub_company) {
          this.$store.dispatch("dispatchSubCompany", user.sub_company);
        }

        if (newMenu.length) {
          this.$store.dispatch("dispatchMainMenu", newMenu);
          this.$store.dispatch("dispatchMenu", newMenu);

          this.$router.push({
            path: newMenu[0].link
          });
        }
        if (newCompanyMenu.length) {
          this.$store.dispatch("dispatchCompanyMenu", newCompanyMenu);
          if (user.company) {
            this.$store.dispatch("dispatchMenu", newCompanyMenu);
            this.$router.push({
              path: newCompanyMenu[0].link
            });
          }
        }
        if (newSubCompanyMenu.length) {
          this.$store.dispatch("dispatchSubCompanyMenu", newSubCompanyMenu);
          if (user.sub_company) {
            this.$store.dispatch("dispatchMenu", newSubCompanyMenu);
            this.$router.push({
              path: newSubCompanyMenu[0].link
            });
          }
        }
      } catch (error) {
        console.log(error);
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          if (error.response.status === 403) {
            this.$infoBar({
              type: "error",
              text: "Wrong username or password"
            });
          }
          if (error.response.status === 404) {
            this.$infoBar({
              type: "error",
              text: "Username and Password doesn't exist"
            });
          }
          if (error.response.status === 401) {
            this.$infoBar({
              type: "error",
              text: "Unauthorized Access"
            });
          }
          if (error.response.status === 500) {
            this.$infoBar({
              type: "error",
              text: "An error has occured while trying to log in"
            });
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
